import { render } from "./TheNotificationBottomArea.vue?vue&type=template&id=398fa170&scoped=true&ts=true"
import script from "./TheNotificationBottomArea.vue?vue&type=script&lang=ts"
export * from "./TheNotificationBottomArea.vue?vue&type=script&lang=ts"

import "./TheNotificationBottomArea.vue?vue&type=style&index=0&id=398fa170&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398fa170"]])

export default __exports__